
import React, { useState } from "react";
import "./Pisco.css";
import EntrevistaDigital from "./EntrevistaDigital";
import EntrevistaProfesional from "./EntrevistaProfesional";
import { Navigate, useNavigate } from "react-router-dom";
import ProcesosPsicoViewer from "./ProcesosPsicoViewer";
import ListadoScl90 from '../SCL_90/ListadoSCL90'
const Pisco = () => {
  const navigate = useNavigate()
  const [modalAbierto, setModalAbierto] = useState(false);
  const [tipoEntrevista, setTipoEntrevista] = useState(null);

  const abrirModal = (tipo) => {
    setTipoEntrevista(tipo);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setTipoEntrevista(null);
  };
const abrirNuevaPestana = () => {

        
        const permitidoDetalle = true

        localStorage.setItem("permitidoDetalle", permitidoDetalle);
        localStorage.setItem("etapa", "Auxiliar Forense 2026");
        localStorage.setItem("niSigedi", "786268");

        const url = "/scl-90-listados";

        window.open(url, "_blank");
    };
  return (
    <div className="pisco-wrapper">

      <div className="pisco-header">
        <h1 className="pisco-title">Gabinete Psicopedagógico</h1>
        <button
          className="pisco-btn-back"
          onClick={() => navigate("/usuarioLogueado")}
        >
          Volver
        </button>
      </div>

      <div className="pisco-cards">

        <div className="pisco-card">
          <div className="pisco-icon">🧩</div>
          <h3>Entrevistas Digitales</h3>
          <p>Gestión de entrevistas digitales.</p>
          <button
            className="pisco-btn-primary"
            onClick={() => abrirModal("digital")}
          >
            Ingresar
          </button>
        </div>

        <div className="pisco-card">
          <div className="pisco-icon">🧠</div>
          <h3>Entrevistas con Profesional</h3>
          <p>Registro de entrevistas presenciales.</p>
          <button
            className="pisco-btn-success"
            onClick={() => abrirModal("profesional")}
          >
            Ingresar
          </button>
        </div>
        <div className="pisco-card">
          <div className="pisco-icon">✔  </div>
          <h3>Procesos de Ingreso</h3>
          <p>Etapas e Instancias</p>
          <button
            className="pisco-btn-success"
            onClick={() => abrirModal("procesos")}
          >
            Ingresar
          </button>
        </div>
         <div className="pisco-card">
          <div className="pisco-icon">  </div>
          <h3>SCL-90</h3>
          <p>Gestor de Formulario</p>
          <button
            className="pisco-btn-success"
            
            onClick={() => abrirNuevaPestana()}
          >
            Ingresar
          </button>
        </div>
      </div>

      {/* MODAL */}
      {modalAbierto && (
        <div className="pisco-modal-overlay">
          <div className="pisco-modal">

            <button
              className="pisco-modal-close"
              onClick={cerrarModal}
            >
              ✖
            </button>

            {tipoEntrevista === "digital" && <EntrevistaDigital />}
            {tipoEntrevista === "profesional" && <EntrevistaProfesional />}
            {tipoEntrevista === "procesos" && <ProcesosPsicoViewer />}
            {tipoEntrevista === "SCL90" && < ListadoScl90/>}

          </div>
        </div>
      )}

    </div>
  );
};

export default Pisco;